
import React from 'react'
import PropTypes from 'prop-types'
import {compose} from 'redux'
import {translate} from 'react-i18next'
import {withStyles} from '@material-ui/core/styles'
import CircularProgress from '@material-ui/core/CircularProgress'
import Typography from '@material-ui/core/Typography'


const styles = theme => ({
  fullScreen: {
    bottom: 0,
    left: 0,
    position: 'fixed',
    right: 0,
    top: 0,
  },
  noticeText: {
    color: theme.palette.primary.light,
    display: 'inline',
    fontSize: 30,
    marginRight: 10,
  },
  noticeWrapper: {
    left: '50%',
    padding: theme.spacing.unit * 4,
    position: 'absolute',
    top: '50%',
    transform: 'translate(-50%, -50%)'
  },
  saveIndicator: {
    backgroundColor: theme.palette.primary.main,
    opacity: 0,
    transition: 'opacity .5s, z-index 0s .5s',
    zIndex: -1,
    '&.active': {
      opacity: 0.75,
      transition: 'opacity .5s',
      zIndex: 1
    }
  }
})

const Indicator = ({classes, isVisible, t, message}) => (
  <div
    className={`${classes.fullScreen} ${classes.saveIndicator} ${isVisible ? 'active' : ''}`}
  >
    <div className={classes.noticeWrapper}>
      <Typography
        className={classes.noticeText}
        variant="subheading"
      >
        {t(message)}
      </Typography>
      <CircularProgress size={24}/>
    </div>
  </div>
)

Indicator.propTypes = {
  isVisible: PropTypes.bool.isRequired
}

export default compose(
  translate(),
  withStyles(styles),
)(Indicator)


// WEBPACK FOOTER //
// ./src/components/common/Indicator.js